// extracted by mini-css-extract-plugin
export default {"sideBtn":"sidebar_sideBtn__nNPAt","popup":"sidebar_popup__8RU+U","arrowTop":"sidebar_arrowTop__5Bnnu","popupWrapper":"sidebar_popupWrapper__cD-Ss"};